import { Icon } from '../ui/icons';
import { useCall } from './CallProvider';

function participantsLabel(n: number): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return `${n} участник`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${n} участника`;
  return `${n} участников`;
}

/**
 * Tells a board member a call is already running, so joining does not depend
 * on someone separately messaging "we're on a call, come in". Same visual
 * language as `FollowBanner` — an unmissable but dismiss-free strip, because
 * both are "something is happening elsewhere that you may want to react to".
 */
export function IncomingCallBanner() {
  const call = useCall();
  if (call.status !== 'idle' || !call.configured || !call.activeCall) return null;

  // The live LiveKit count. Zero means nobody has been reported yet (the
  // starter is still connecting, or LiveKit could not be asked) — then no
  // number is shown rather than a made-up one.
  const count = call.activeCallParticipants;

  return (
    <div className="incoming-call-banner" role="status">
      <span className="incoming-call-dot" />
      <span className="incoming-call-text">
        <strong>{call.activeCall.startedByName}</strong> начал(а) звонок
        {count > 0 && <span className="incoming-call-count"> · {participantsLabel(count)}</span>}
      </span>
      <button type="button" className="primary-btn" onClick={() => void call.join()}>
        <Icon name="phone" size={14} /> Присоединиться
      </button>
    </div>
  );
}
